var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('f7-app',{attrs:{"params":_vm.f7Params}},[_c('side-menu'),_c('f7-view',{attrs:{"url":"/","main":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }